import { TOGGLE_REFRESH_TIMER } from '../actions/types/MrdMonitoringActionTypes';
import { AUTH_LOGOUT } from '../../../../common/redux/actions/types/authActionTypes';

export const initialState = {
  isRefreshTimerActive: true,
};

const MrdMonitoringReducer = (state = initialState, action) => {
  switch (action.type) {
  case TOGGLE_REFRESH_TIMER:
    return {
      ...state,
      isRefreshTimerActive: !state.isRefreshTimerActive,
    };
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default MrdMonitoringReducer;
